import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CrowdFlowSensorSite } from '../../model/crowd-flow-sensor-site';

export interface CrowdFlowSensorSiteState extends EntityState<CrowdFlowSensorSite> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'CrowdFlowSensorSite' })
export class CrowdFlowSensorSiteStore extends EntityStore<CrowdFlowSensorSiteState> {

  constructor() {
    super();
  }

}
